import QRCode from "react-qr-code";
import { permitMeta } from "../lib/permitSchemas";
import { Logo } from "./Logo";

function fmt(dt) {
  if (!dt) return "—";
  try {
    return new Date(dt).toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return dt;
  }
}

export function Badge({ permit }) {
  const verify = permit.verify_url || (permit.contractor_id ? `${window.location.origin}/verify/${permit.contractor_id}` : null);
  const qrValue = verify || JSON.stringify({
    n: permit.permit_number,
    name: permit.contractor_name,
    co: permit.company,
    site: permit.site || undefined,
    exp: permit.expiry_at,
  });
  return (
    <div
      className="badge-sheet mx-auto w-[320px] overflow-hidden rounded-lg border border-border bg-white shadow-md"
      data-testid="id-badge"
    >
      <div className="flex items-center gap-3 px-4 py-3 badge-banner" style={{ background: "#00355e" }}>
        <Logo variant="dark" showName={false} />
        <div className="border-l border-white/30 pl-3 font-heading text-2xl font-bold leading-none text-white">Contractor</div>
      </div>
      <div className="flex gap-3 p-4">
        <div className="h-28 w-24 flex-shrink-0 overflow-hidden rounded-md border border-border bg-neutral-100">
          {permit.contractor_photo ? (
            <img src={permit.contractor_photo} alt={permit.contractor_name} className="h-full w-full object-cover" />
          ) : (
            <div className="flex h-full w-full items-center justify-center text-xs text-neutral-400">No photo</div>
          )}
        </div>
        <div className="min-w-0 flex-1">
          <div className="font-heading text-lg font-bold leading-tight tracking-tight text-brand">{permit.contractor_name}</div>
          <div className="truncate text-sm text-muted-foreground">{permit.company}</div>
          <div className="mt-1 text-xs text-muted-foreground">DBS: {permit.id_number || "—"}</div>
          {permit.site && <div className="mt-1 text-xs font-semibold text-foreground">{permit.site}</div>}
          {permit.permit_number && <div className="mt-1 text-[11px] font-semibold uppercase tracking-wide text-brand">{permit.permit_number}</div>}
        </div>
      </div>
      <div className="px-4 pb-2">
        <div className="mb-1 text-[10px] font-semibold uppercase tracking-[0.15em] text-muted-foreground">Permits granted</div>
        <div className="flex flex-wrap gap-1.5">
          {(permit.permit_types || []).length === 0 && <span className="text-[11px] text-muted-foreground">Induction only</span>}
          {(permit.permit_types || []).map((t) => {
            const m = permitMeta(t);
            return (
              <span key={t} className="rounded px-2 py-0.5 text-[11px] font-semibold text-white" style={{ background: m?.color || "#00355e" }}>
                {m?.title || t}
              </span>
            );
          })}
        </div>
      </div>
      <div className="flex items-end justify-between gap-3 px-4 pb-4 pt-2">
        <div className="text-[11px] leading-tight text-muted-foreground">
          <div>{permit.inducted_at ? "Inducted" : "Valid from"}</div>
          <div className="font-semibold text-foreground">{fmt(permit.inducted_at || permit.issue_at)}</div>
          <div className="mt-1">Expires</div>
          <div className="font-semibold text-destructive">{fmt(permit.expiry_at)}</div>
        </div>
        <div className="rounded bg-white p-1">
          <QRCode value={qrValue} size={72} fgColor="#00355e" />
        </div>
      </div>
      <div className="px-4 pb-2 text-center text-[9px] uppercase tracking-[0.2em] text-white badge-banner" style={{ background: "#00355e" }}>
        <div className="py-1">Must be worn & visible at all times on site</div>
      </div>
    </div>
  );
}
